module.exports = __webpack_public_path__ + "static/media/logo-nst.bfd7f501.png";